import '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';

var _window = void 0;

try {
  _window = window;
} catch (e) {}

function getWindow(node) {
  var _node$ownerDocument$d, _node$ownerDocument;

  return (_node$ownerDocument$d = node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) != null ? _node$ownerDocument$d : _window;
}

function checkIsBrowser() {
  var _window2 = getWindow();

  return Boolean(typeof _window2 !== "undefined" && _window2.document && _window2.document.createElement);
}

var isBrowser = /*#__PURE__*/checkIsBrowser();
function isFunction(value) {
  return typeof value === "function";
}
function createContext(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? true : _options$strict,
      _options$errorMessage = _options.errorMessage,
      errorMessage = _options$errorMessage === void 0 ? "useContext must be inside a Provider with a value" : _options$errorMessage,
      name = _options.name;
  var Context = React__default.createContext(void 0);
  Context.displayName = name;

  function useContext() {
    var context = React__default.useContext(Context);
    if (!context && strict) throw new Error(errorMessage);
    return context;
  }

  return [Context.Provider, useContext, Context];
}
var __DEV__ = process.env.NODE_ENV !== "production";
function runIfFn(valueOrFn) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function warn(options) {
  if (options.condition && __DEV__) {
    console.warn(options.message);
  }
}
var startPad = function startPad(n, z, s) {
  if (z === void 0) {
    z = 2;
  }

  if (s === void 0) {
    s = "0";
  }

  return (n + "").length <= z ? ["", "-"][+(n < 0)] + (s.repeat(z) + Math.abs(n)).slice(-1 * z) : n + "";
};

export { __DEV__, createContext, getWindow, isBrowser, isFunction, runIfFn, startPad, warn };
//# sourceMappingURL=index.esm.js.map
